// These are used to inform the navigation context about which sphere is highlighted
enum FocusPoints {
    None,
    Overview,
    SubspaceHusband,
    SubspaceCat,

    TopoligicalCat,
    TopologicalHusband,
    TopoligicalWife,

    DynamicBehaviorExpectation,
    DynamicBehaviorReality
}

export default FocusPoints;